/**
 * links.js — every store / outbound URL the marketing pages use (spec §4.1).
 *
 * The raw store ids come from src/app/data/appLinks.js (shared with the portal, never edited here).
 * Play links carry a `referrer` so Play Console can attribute installs per placement even though
 * web analytics records nothing today (see track.js).
 */
import { KMO_PLAY_URL, SMH_PLAY_URL, detectPlatform } from '../app/data/appLinks';

export { KMO_PLAY_URL, detectPlatform };
export const BMB_PLAY_URL = SMH_PLAY_URL; // store id never changes
export const BMB_IOS_URL = 'https://apps.apple.com/app/id6759518742'; // slug-free canonical
export const BESTAPP_URL = 'https://www.bestapp.com/best-apps-to-limit-phone-use/';
/** UpdateStar's own listing — the source of its "Very Good" award and its 4-out-of-5 user rating. */
export const UPDATESTAR_URL = 'https://keep-me-out-phone-lock.updatestar.com/';
export const SUPPORT_EMAIL = 'keepmeout.help@eudaitec.com';

export function withPlayReferrer(url, campaign) {
  const ref = `utm_source=keepmeout.app&utm_medium=website&utm_campaign=${campaign}`;
  return `${url}&referrer=${encodeURIComponent(ref)}`;
}
export const kmoPlayHref = (placement) => withPlayReferrer(KMO_PLAY_URL, `kmo_${placement}`);
export const bmbPlayHref = (placement) => withPlayReferrer(BMB_PLAY_URL, `bmb_${placement}`);
// Add ?pt=<token>&ct=<placement>&mt=8 only when the owner supplies the App Store provider token.
export const bmbAppStoreHref = () => BMB_IOS_URL;
